import { Avatar as AvatarA } from '@pba/react-components';
import type { ComponentProps } from 'react';
import { images } from 'common/utils';

export type AvatarProperties = Omit<BaseAvatarProperties, 'fallbackPhoto'> &
  Partial<Pick<BaseAvatarProperties, 'fallbackPhoto'>>;

type BaseAvatarProperties = ComponentProps<typeof AvatarA>;

const Avatar = ({ fallbackPhoto, ...rest }: AvatarProperties) => (
  <AvatarA fallbackPhoto={fallbackPhoto ?? images.default.userProfilePhoto} {...rest} />
);

export default Avatar;
